import { t } from "i18next"
import {
    Avatar,
    Button,
    Chip,
    Dropdown,
    fetchRoute,
    getCalendarFormat,
    Icon,
    Link,
    TDataTableColumnsData,
    Typography
} from "@cakemail-org/ui-components-v2"
import { Stack } from "@mui/material"
import { TGetListingRowsPage } from "./types"
import { NameTableCol } from "../../components/tables/nameTableCol"
import { ERoutes } from "../../utils/url"


export function getListingColsData(): () => TDataTableColumnsData[] {
    return () => [
        {
            id: "name",
            label: t("general-page_other"),
            sortable: true
        },
        {
            id: "published_on",
            label: t("general-status"),
            sortable: true
        },
        {
            id: "branding",
            label: t("general-branding"),
            sortable: true
        },
        {
            id: "list_id",
            label: t("general-list_one"),
            sortable: true
        },
        {
            id: "created_on",
            label: t("general-created_on"),
            sortable: true
        },
        {
            id: "updated_on",
            label: t("general-updated_on"),
            sortable: true
        },
        {
            id: "edited_by",
            label: t("general-edited_by"),
        },
        {
            id: "actions",
            label: ""
        }
    ]
}

export function getListingRows({
    page,
    partialList,
    users,
    handleOpenPage,
    handlePreviewPage,
    handleRenamePage,
    handleDuplicatePage,
    handleDeletePage,
    handleCopyPageUrl,
}: TGetListingRowsPage) {
    const actions = <Stack direction="row" gap={3}>
        <Button
            onClick={() => { handleOpenPage(page) }}
            size="small"
            color="body1"
            variant="outlined"
        >{t("general-open_one")}</Button>
        <Dropdown
            size="medium"
            color="body1"
            variant="outlined"
            iconOnly
            options={[
                {
                    isAction: true,
                    text: t("general-preview"),
                    postContent: <Icon name="Preview18" />,
                    onClick: () => { handlePreviewPage(page) }
                },
                {
                    isAction: true,
                    text: t("pages-copy-url"),
                    postContent: <Icon name="Copy18" />,
                    onClick: () => { handleCopyPageUrl(page) },
                    disabled: !page.published_on
                },
                {
                    isAction: true,
                    text: t("general-rename"),
                    postContent: <Icon name="Edit18" />,
                    onClick: () => { handleRenamePage(page) }
                },
                {
                    isAction: true,
                    text: t("general-duplicate"),
                    postContent: <Icon name="Document18" />,
                    onClick: () => { handleDuplicatePage(page) }
                },
                {
                    isAction: true,
                    text: t("general-delete"),
                    postContent: <Icon name="Delete18" />,
                    onClick: () => { handleDeletePage(page) }
                }
            ]}
        />
    </Stack>

    const editedBy = users && users[page.edited_by.id]
    const isSmartBranding = page.branding === "smart"
    return {
        name: {
            id: page.name || "",
            content: <NameTableCol name={page.name || ""} desc={page.description || ""} imgSrc={page.thumbnail_url} />
        },
        edited_by: editedBy ? <Stack direction="row" gap={3} alignItems="center">
            <Avatar variant="square" email={editedBy.email} firstName={editedBy.first_name} lastName={editedBy.last_name} />
            <Typography variant="body1L">{editedBy.first_name} {editedBy.last_name}</Typography>
        </Stack> : "-",
        list_id: <Link href={"#" + fetchRoute({ route: ERoutes.contacts }) + "?listId=" + page.list_id}>{partialList?.name || page.list_id}</Link>,
        published_on: <Chip label={page.published_on && page.published_on > 0 ? t("general-published") : t("general-unpublished")} color={page.published_on && page.published_on > 0 ? "secondary" : "primary"} />,
        branding: <Chip label={t(isSmartBranding ? "general-smart" : "general-basic")} color={isSmartBranding ? "shade150" : "shade150"} />,
        created_on: <Typography variant="body1L">{page.created_on !== 0 ? getCalendarFormat({ date: page.created_on, showTime: true }) : ""}</Typography>,
        updated_on: <Typography variant="body1L">{page.updated_on !== 0 ? getCalendarFormat({ date: page.updated_on, showTime: true }) : ""}</Typography>,
        actions
    }
}
